import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review for Lemonade Shoes, read off their public Faire
// reviews list (Ryan, 2026-08-17) — verbatim comment, real reviewer, real
// rating. Brand reviews carry no product token, so the spotlight module renders
// this one without thumbnails.
export const review_ls5: FaireReviewEntity = {
  token: "review_ls5",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  reviewType: "brand",
  reviewerName: "Kavi",
  reviewerLocation: "Naperville, IL",
  stars: 5,
  reviewText: "Amazing line of shoes, with an amazing team behind it.",
  reviewDate: "Sep 3, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-17T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
